import React from 'react';
import { createPortal } from 'react-dom';
import { StyledPortal } from './styled';

export default ({ id, children }) => {
    if(document.getElementById(id) === null) {
        const portalRoot = document.createElement('div');
        portalRoot.setAttribute("id", id);
        document.body.appendChild(portalRoot);
    }

    return createPortal(<StyledPortal>{children}</StyledPortal>, document.getElementById(id));
};